import React, { useRef, useEffect } from "react";
import ReactDOM from 'react-dom/client';
import { useSelector, useDispatch } from "react-redux";
import Message from "./Message";
import UserTyping from "./UserTyping";
import WideButton from "./WideButton";
import { useTranslation } from 'react-i18next';
import * as EmailValidator from 'email-validator';

const Conversation = () => {
  const dispatch = useDispatch();
  const endMessages = useRef(null);
  const messages = useSelector(state => state.app.messages);
  const { t, i18n } = useTranslation();
  const isClient = useSelector(state => state.app.isClient);
  const messageToSend = useSelector(state => state.app.messageToSend);
  const uuid = useSelector(state => state.uuid.uuid);
  const emailValidation = useSelector(state => state.app.emailValidation);
  const clientEmail = useSelector(state => state.app.clientEmail);
  const conversationStarted = useSelector(state => state.app.conversationStarted);
  const textarea = useSelector(state => state.app.textarea);
  const isDivWidget = useSelector(state => state.launcher.isDivWidget);
  const sendToAIAssistant = useSelector(state => state.app.sendToAIAssistant);
  const hideTalkToHuman = useSelector(state => state.app.hideTalkToHuman);

  let divConversationHeight = 250 + textarea.diffHeight;
  if (sendToAIAssistant && isClient && !hideTalkToHuman) {
    divConversationHeight = divConversationHeight + 40;
  }
  let divConversationHeightStyle = { height: `calc(100vh - ${divConversationHeight}px)` };
  if (isDivWidget) {
    divConversationHeightStyle.height = `calc(445px - ${textarea.diffHeight}px)`;
  }

  let emailInput = useRef(null);

  useEffect(() => {
    if (!messages.length) {
      return;
    }
    endMessages.current?.scrollIntoView();
  }, []);

  useEffect(() => {
    if (!messages.length) {
      return;
    }
    endMessages.current?.scrollIntoView();
  }, [messages]);

  useEffect(() => {
    endMessages.current?.scrollIntoView();
  }, [(textarea) ? textarea.diffHeight : null]);

  const onClick = (e) => {
    e.preventDefault();

    if (!EmailValidator.validate(emailInput.current.value)) {
      dispatch({ type: 'SET_EMAIL_INVALID'});
      return;
    }

    const lastMessage = [...messages].pop();
    const date = (lastMessage) ? lastMessage.date : null;
    dispatch({ type: 'SEND_MESSAGE', message: messageToSend, channel: uuid, lastDate: date, files: [], email: emailInput.current.value });
  }

  const onKeyDown = (e) => {
    if (e.which != 13) {
      return;
    }
    
    if (!EmailValidator.validate(emailInput.current.value)) {
      dispatch({ type: 'SET_EMAIL_INVALID'});
      return;
    }

    const lastMessage = [...messages].pop();
    const date = (lastMessage) ? lastMessage.date : null;
    dispatch({ type: 'SEND_MESSAGE', message: messageToSend, channel: uuid, lastDate: date, files: [], email: emailInput.current.value });
  }

  if ((!isClient && !messageToSend) || (clientEmail && !conversationStarted)) {
    return (
      <>
      <div className="kil-chat-widget-conversation" style={divConversationHeightStyle}>
        <div className="kil-chat-widget-conversation-empty">
          <div className="kil-chat-widget-conversation-empty-txt">
            {t('Please, send your message to start a conversation')}
          </div>
        </div>
      </div>
      
      <UserTyping />
      
      </>
    );
  }

  if (!isClient) {
    return (
      <>
      <div className="kil-chat-widget-conversation" style={divConversationHeightStyle}>
        <div className="kil-chat-widget-conversation-empty">
          <div className="kil-chat-widget-conversation-empty-txt">

            <p className="kil-chat-widget-conversation-empty-txt-p">
              {t('Please, introduce yourself to start a conversation')}
            </p>

            <div className="form-group">
              <input autoFocus onKeyDown={onKeyDown} ref={emailInput} type="email" className={"conversation-email-input form-control" + (!emailValidation ? ' is-invalid' : '')} placeholder={t('Enter email address..')} />
              {!emailValidation && 
                <div className="invalid-feedback">{t('This value is not a valid email address.')}</div>
              }
            </div>
            <div className="form-group">
              <button onClick={onClick} type="submit" className="btn btn-send-mail btn-block">{t('Send')}</button>
            </div>
          </div>
        </div>
      </div>
      
      <UserTyping />

      </>
    );
  }

  return (
    <>
    <div className="kil-chat-widget-conversation" style={divConversationHeightStyle}>

      {messages.map((message, i) => (
        <Message key={message.id} message = {message} />
      ))}

      <div ref={endMessages}></div>
    </div>
    
    <UserTyping />
    {sendToAIAssistant && !hideTalkToHuman &&
      <WideButton />
    }

    </>
  );
}

export default Conversation;